import { View } from './Themed';

export const Layout: React.FC = ({ children }) => {
  return <View style={{ padding: 24, flex: 1 }}>{children}</View>;
};
